<template>
  <a-modal
    :visible="visible"
    :closable="false"
    :footer="null"
    :destroy-on-close="true"
    :width="676"
    :title="$t('page_business_data_preview_Img')"
    :ok-text="$t('save')"
    :cancel-text="$t('cancel')"
    @cancel="handleCancel"
  >
    <div class="box">
      <template v-for="(img, i) in imgsNative">
        <div
          v-if="i === currentIndex"
          :key="i"
          style="margin: 0 auto; position: relative; width: 600px; height: 600px"
        >
          <img
            v-if="img && img.type === 'image'"
            style="position: absolute; top: 50%; left: 50%; max-width: 100%; max-height: 100%"
            :src="img.img"
            :style="{
              transform: `translate(-50%, -50%) rotate(${img.rotate}deg)`,
            }"
          />
          <embed
            v-if="img && img.type === 'application'"
            style="position: absolute; top: 50%; left: 50%; width: 100%; height: 100%"
            :src="img.img"
            type="application/pdf"
            :style="{
              transform: `translate(-50%, -50%) rotate(${img.rotate}deg)`,
            }"
          />
          <div v-if="img && img.type === 'text'">
            <div class="txt-title">
              <a-select
                v-model="encodeType"
                @change="changeEncode"
                style="width: 100%;"
              >
                <a-select-option
                  v-for="(type, index) in encodingTypes"
                  :key="index"
                  :value="type"
                  >{{ type }}</a-select-option
                >
              </a-select>
            </div>
            <textarea
              style="position: absolute; top: 50%; left: 50%; max-width: 100%; max-height: 100%"
              v-model="img.img"
              disabled
              class="txt-content"
              :style="{
                transform: `translate(-50%, -50%) rotate(${img.rotate}deg)`,
              }"
            />
          </div>
        </div>
      </template>

      <div class="bar">
        <a-icon type="left" class="item" @click="onLeft"></a-icon>
        <a-icon type="undo" class="item" @click="onRotateLeft" />
        <a-icon type="redo" class="item" @click="onRotateRight" />
        <a-icon type="right" class="item" @click="onRight"></a-icon>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "",
  props: {
    imgs: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    defaultList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      currentIndex: 0,
      imgsNative: [],
      encodeType: 'UTF-8',
      encodingTypes: ['ANSI', 'UTF-16 LE', 'UTF-16 BE', 'UTF-8', 'GBK', 'Big5', ' Shift-JIS']
    };
  },
  computed: {
    length() {
      return this.imgs.length;
    },
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.currentIndex = this.index;
        }
      },
      immediate: true,
    },
    index: {
      handler(newVal) {
        this.currentIndex = newVal;
      },
      immediate: true,
    },
    imgs: {
      handler(newVal) {
        const imgDoms = newVal.map((item) => {
          if (item && item.content && item.type && item.type != "text") {
            const img = document.createElement("img");
            img.src = item.content;
            img.type = item.type;
            return img;
          } else if (
            item &&
            item.content &&
            item.type &&
            item.type === "text"
          ) {
            const img = {
              src: item.content,
              type: item.type,
            };
            return img;
          }
        });
        this.$nextTick(() => {
          this.imgsNative = imgDoms.map((img, i) => {
            if (img && img.type && img.type === "text") {
              const width = img.width;
              const height = img.height;
              const size = width > height ? width : height;
              const max = size > 600 ? 600 : size;
              return {
                img: img.src,
                rotate: 0,
                size: max,
                type: img.type,
              };
            } else if (img && img.type && img.type != "text") {
              return {
                img: img.src,
                rotate: 0,
                size: 600,
                type: img.type,
              };
            }
          });
        });
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    onLeft() {
      this.currentIndex =
        this.currentIndex - 1 >= 0 ? this.currentIndex - 1 : this.length - 1;
    },
    onRight() {
      this.currentIndex =
        this.currentIndex + 1 <= this.length - 1 ? this.currentIndex + 1 : 0;
    },
    onRotateLeft() {
      this.imgsNative[this.currentIndex].rotate -= 90;
    },
    onRotateRight() {
      this.imgsNative[this.currentIndex].rotate += 90;
    },
    changeEncode (val) {
      this.$emit('changeEncode', val)
      this.$emit('changeRecordEncode', val)
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  position: relative;
  background-size: 100% 100%;
  padding-top: 0;
  padding-bottom: 80px;
  .title {
    position: absolute;
    top: 30px;
    left: 40px;
    color: #000;
  }
}
.bar {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  position: absolute;
  left: 36px;
  right: 36px;
  bottom: 40px;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.6);
  .item {
    font-size: 32px;
    color: #fff;
    &:hover {
      color: #ccc;
    }
  }
}
.txt-content {
  width: 496px;
  margin: 0 auto 16px;
  height: calc(100% - 69px - 32px);
  background-color: #f5f5f5;
  border-radius: 2px;
  border: solid 1px rgba(0, 0, 0, 0.15);
  padding: 8px;
  display: block;
  resize: none;
}
  .txt-title {
    width: 496px;
    margin: 0 auto 16px;
    display: flex;

    .title-label {
      color: rgba(0, 0, 0, 0.85);
    }

    .title-value {
      color: rgba(0, 0, 0, 0.65);
    }
  }
</style>
